export default __webpack_public_path__ + "static/media/docComingSoon.bac6471c.svg";